// src/components/common/CtaBanner.jsx
import React from 'react';
import styles from './CtaBanner.module.css';

const CtaBanner = ({ title, subtitle, buttonText, buttonLink = '/contact' }) => {
  return (
    <section className={styles.ctaBanner}>
      <div className={styles.ctaContent}>
        <h2>{title}</h2>
        <p>{subtitle}</p>
        <a href={buttonLink} className="cta-button">
          {buttonText}
        </a>
      </div>
    </section>
  );
};

export default CtaBanner;